import { getCategory, getPublisher, getSearchMetaData } from '@sbt-web/tracking';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getSubitoDataLayer = () => {
    if (!window.subito || !window.subito.dataLayer) {
        throw new Error('Missing Data Layer for AdReply event.');
    }
    return window.subito.dataLayer;
};
const phoneContactTrackingEvent = ({ pulseInstance, item, search, type, pageID, }) => {
    const { urn, category, advertiser } = item;
    try {
        const dataLayer = getSubitoDataLayer();
        pulseInstance?.queueEvent({
            type,
            search: search ? getSearchMetaData(search.id, search.rank) : undefined,
            object: {
                '@type': 'PhoneContact',
                inReplyTo: {
                    '@id': `sdrn:subito:classified:${urn}`,
                    '@type': 'ClassifiedAd',
                    name: dataLayer.page.name,
                    publisher: getPublisher(advertiser.userId, advertiser.type),
                    category: getCategory(category.id),
                },
            },
            page: {
                '@id': `sdrn:subito:page:${pageID}`,
                pageType: pageID,
                '@type': 'Page',
            },
        });
    }
    catch {
        return;
    }
};

export { phoneContactTrackingEvent };
//# sourceMappingURL=tracking.js.map
